(() => {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    const n = cents / 100;
    return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  async function fetchProductJS(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load product JSON");
    return res.json();
  }

  function findProductForm(toggleEl, sectionId) {
    const form = document.querySelector(`#product-form-${sectionId}`);
    if (form) return form;
    return (
      toggleEl.closest(".product__info-container")?.querySelector('form[action^="/cart/add"]') || null
    );
  }

  function getCurrentVariantId(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }

  function getVariantAllocations(productJs, variantId) {
    const v = productJs.variants.find((x) => x.id === variantId);
    return v?.selling_plan_allocations || [];
  }

  function buildSellingPlansById(productJs) {
    const map = new Map();
    (productJs.selling_plan_groups || []).forEach((g) => {
      (g.selling_plans || []).forEach((sp) => map.set(sp.id, sp));
    });
    return map;
  }

  function buildCadenceMenu(toggleEl, allocations, sellingPlansById) {
    const menu = toggleEl.querySelector("[data-ml-cadence-menu]");
    if (!menu) return;
    menu.innerHTML = "";
    allocations.forEach((alloc) => {
      const sp = sellingPlansById.get(alloc.selling_plan_id);
      if (!sp) return;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ml-cadence-option";
      btn.dataset.mlSellingPlanId = String(alloc.selling_plan_id);
      btn.textContent = sp.name || "Delivery option";
      menu.appendChild(btn);
    });
    const cadenceWrap = toggleEl.querySelector("[data-ml-cadence]");
    if (cadenceWrap) cadenceWrap.style.display = allocations.length ? "" : "none";
  }

  function deriveDiscountPercent(otpCents, subCents) {
    if (!otpCents || !subCents) return null;
    const pct = Math.round((1 - subCents / otpCents) * 100);
    return Number.isFinite(pct) ? pct : null;
  }

  function updatePrices(toggleEl, otpCents, subCents) {
    const otpEl = toggleEl.querySelector("[data-ml-price-otp]");
    const discountEl = toggleEl.querySelector("[data-ml-discount]");
    if (otpEl) otpEl.textContent = formatMoney(otpCents);
    const pct = deriveDiscountPercent(otpCents, subCents);
    if (pct != null && discountEl) discountEl.textContent = `${pct}%`;
    return { otpCents, subCents };
  }

  function setSellingPlan(form, sellingPlanId) {
    const sp = form.querySelector('[data-ml-selling-plan-input], input[name="selling_plan"]');
    if (!sp) return;
    if (sellingPlanId) {
      sp.value = String(sellingPlanId);
      sp.disabled = false;
      sp.removeAttribute("disabled");
    } else {
      sp.value = "";
      sp.disabled = true;
      sp.setAttribute("disabled", "disabled");
    }
  }

  function buildPayloadFromForm(form, { stripSellingPlan } = { stripSellingPlan: false }) {
    const params = new URLSearchParams();
    const fields = form.querySelectorAll("input, select, textarea");
    fields.forEach((el) => {
      if (!el.name) return;
      if (el.disabled) return;
      if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
      const name = el.name;
      const lower = name.toLowerCase();
      if (stripSellingPlan) {
        if (lower.includes("selling_plan")) return;
        if (lower.includes("subscription") || lower.includes("skio")) return;
        if (lower.startsWith("properties[")) {
          if (lower.includes("skio") || lower.includes("subscription") || lower.includes("selling_plan")) return;
        }
      }
      params.append(name, el.value);
    });
    if (!params.get("id")) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value) params.set("id", idInput.value);
    }
    if (!params.get("quantity")) params.set("quantity", "1");
    return params;
  }

  async function addToCartAjax(form, mode) {
    const strip = mode === "otp";
    if (strip) setSellingPlan(form, null);
    const body = buildPayloadFromForm(form, { stripSellingPlan: strip });
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: body.toString(),
      credentials: "same-origin",
    });
    if (!res.ok) {
      let errText = "";
      try { errText = await res.text(); } catch (_) {}
      throw new Error(`Add failed (${res.status}): ${errText}`);
    }
    return res.json();
  }

  function notifyThemeCartUpdated() {
    const events = [
      "cart:refresh", "cart:updated", "cart:change",
      "theme:cart:updated", "theme:cart:refresh",
      "cart-drawer:refresh", "cart-drawer:updated",
    ];
    events.forEach((name) => {
      try {
        document.dispatchEvent(new CustomEvent(name));
        window.dispatchEvent(new CustomEvent(name));
      } catch (_) {}
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      const count = cart?.item_count;
      if (typeof count !== "number") return;
      document.querySelectorAll("cart-count").forEach((el) => {
        try {
          el.textContent = String(count);
          el.setAttribute("aria-label", `${count} item${count === 1 ? "" : "s"}`);
        } catch (_) {}
      });
    } catch (_) {}
  }

  function getCartDrawerRoot() {
    return (
      document.querySelector("cart-drawer") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector('[id*="CartDrawer"]') ||
      document.querySelector('[data-cart-drawer]') ||
      null
    );
  }

  function getCartDrawerDetailsEl() {
    return (
      document.querySelector("details#Details-CartDrawer") ||
      document.querySelector('details[id*="CartDrawer"]') ||
      null
    );
  }

  function openCartDrawerByThemeTrigger() {
    const candidates = [
      'details#Details-CartDrawer > summary',
      'details[id*="CartDrawer"] > summary',
      'summary[aria-controls="CartDrawer"]',
      'summary[aria-controls="cart-drawer"]',
      "#cart-icon-bubble", "a#cart-icon-bubble", "button#cart-icon-bubble",
      '[data-cart-drawer-open]', '[data-open-cart-drawer]', '[data-cart-toggle]',
      '[data-drawer-id="cart"]', '[aria-controls="CartDrawer"]', '[aria-controls="cart-drawer"]',
      "button.header__icon--cart", "a.header__icon--cart",
      'a[href="/cart"][data-drawer-trigger]', 'button[name="open-cart"]',
      'button[data-action="open-cart"]',
    ];
    for (const sel of candidates) {
      const nodes = document.querySelectorAll(sel);
      for (const node of nodes) {
        if (!node) continue;
        const rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) continue;
        try { node.click(); return true; } catch (_) {}
      }
    }
    return false;
  }

  function closeCartDrawerSafely() {
    const drawer = getCartDrawerRoot();
    if (drawer) {
      try {
        if (typeof drawer.close === "function") { drawer.close(); return true; }
        if (typeof drawer.hide === "function") { drawer.hide(); return true; }
      } catch (_) {}
    }
    const details = getCartDrawerDetailsEl();
    if (details) {
      try { details.open = false; return true; } catch (_) {}
    }
    if (drawer) {
      try {
        drawer.classList.remove("active", "is-open", "open");
        drawer.setAttribute("aria-hidden", "true");
        return true;
      } catch (_) {}
    }
    return false;
  }

  function ensureCartCloseWorksOnce() {
    if (document.documentElement.dataset.mlCartCloseBound === "true") return;
    document.documentElement.dataset.mlCartCloseBound = "true";
    document.addEventListener("click", (e) => {
      const target = e.target;
      const closeSelectors = [
        '[data-cart-drawer-close]', '[data-drawer-close]',
        'button[aria-label="Close"]', 'button[aria-label="close"]',
        ".drawer__close", ".drawer__close-button", ".cart-drawer__close",
        "#CartDrawer-Overlay", ".drawer__overlay", ".cart-drawer__overlay",
      ];
      const closeHit = closeSelectors.some((sel) => target?.closest?.(sel));
      if (!closeHit) return;
      const drawer = getCartDrawerRoot() || getCartDrawerDetailsEl();
      if (!drawer) return;
      const isRelated = drawer.contains(target) || target?.id === "CartDrawer-Overlay";
      if (!isRelated) return;
      e.preventDefault();
      e.stopPropagation();
      closeCartDrawerSafely();
    }, true);
  }

  function wireCadenceDropdown(toggleEl, onSelect) {
    const trigger = toggleEl.querySelector("[data-ml-cadence-trigger]");
    const menu = toggleEl.querySelector("[data-ml-cadence-menu]");
    const label = toggleEl.querySelector("[data-ml-cadence-label]");
    if (!trigger || !menu) return;
    if (trigger.dataset.mlBound === "true") return;
    trigger.dataset.mlBound = "true";
    trigger.addEventListener("click", () => {
      const isHidden = menu.hasAttribute("hidden");
      if (isHidden) menu.removeAttribute("hidden");
      else menu.setAttribute("hidden", "");
    });
    menu.addEventListener("click", (e) => {
      const btn = e.target.closest(".ml-cadence-option");
      if (!btn) return;
      const spId = Number(btn.dataset.mlSellingPlanId);
      if (label) label.textContent = btn.textContent || "Delivery option";
      menu.setAttribute("hidden", "");
      onSelect(spId);
    });
    document.addEventListener("click", (e) => {
      if (!toggleEl.contains(e.target)) menu.setAttribute("hidden", "");
    });
  }

  // ---- setActiveMode: only toggles classes + perks/cadence visibility ----
  // Price row is ALWAYS visible. Both data-ml-price-otp and data-ml-price-active
  // are always populated. We just toggle which mode is active so CSS can style it.
  function setActiveMode(toggleEl, mode) {
    const subBtn = toggleEl.querySelector('[data-ml-purchase="sub"]');
    const otpBtn = toggleEl.querySelector('[data-ml-purchase="otp"]');
    const perks = toggleEl.querySelector("[data-ml-perks]");
    const cadenceWrap = toggleEl.querySelector("[data-ml-cadence]");

    if (subBtn) subBtn.classList.toggle("is-active", mode === "sub");
    if (otpBtn) otpBtn.classList.toggle("is-active", mode === "otp");
    if (perks) perks.style.display = mode === "sub" ? "" : "none";
    if (cadenceWrap) cadenceWrap.style.display = mode === "sub" ? "" : "none";

    toggleEl.classList.toggle("is-subscribe", mode === "sub");
    toggleEl.classList.toggle("is-onetime", mode === "otp");
    toggleEl.dataset.mlMode = mode;
  }

  // ---- updatePriceRow: always sets both price spans and the active label ----
  function updatePriceRow(toggleEl, otpCents, subCents, mode) {
    const otpEl = toggleEl.querySelector("[data-ml-price-otp]");
    const activeEl = toggleEl.querySelector("[data-ml-price-active]");
    const activeLabel = toggleEl.querySelector(".ml-active .label");
    const totalLabel = toggleEl.querySelector(".ml-total .label");

    // data-ml-price-otp always shows full (non-discounted) price
    if (otpEl) otpEl.textContent = formatMoney(otpCents);

    if (mode === "sub") {
      // Subscription: "Total value" = full price (already set above), "Your cost" = sub price
      if (totalLabel) totalLabel.textContent = "Total value";
      if (activeLabel) activeLabel.textContent = "Your cost";
      if (activeEl) activeEl.textContent = formatMoney(subCents);
    } else {
      // OTP: repurpose both columns to just show the single OTP price clearly
      if (totalLabel) totalLabel.textContent = "Price";
      if (otpEl) otpEl.textContent = formatMoney(otpCents);
      if (activeLabel) activeLabel.textContent = "";
      if (activeEl) activeEl.textContent = "";
    }
  }

  function observeVariantChanges(form, onChange) {
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    const obs = new MutationObserver(() => onChange());
    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    idInput.addEventListener("change", onChange);
  }

  async function initToggle(toggleEl) {
    const handle = toggleEl.dataset.productHandle;
    const sectionId = toggleEl.dataset.sectionId;
    if (!handle || !sectionId) return;

    const form = findProductForm(toggleEl, sectionId);
    if (!form) return;

    const productJs = await fetchProductJS(handle);
    const sellingPlansById = buildSellingPlansById(productJs);

    ensureCartCloseWorksOnce();

    if (!form.dataset.mlAddInterceptor) {
      form.dataset.mlAddInterceptor = "true";
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const mode = toggleEl.dataset.mlMode || "sub";
        const submitBtn = form.querySelector('[type="submit"][name="add"], [type="submit"]');
        if (submitBtn) submitBtn.setAttribute("aria-busy", "true");
        try {
          await addToCartAjax(form, mode);
          notifyThemeCartUpdated();
          await refreshCartCount();
          const opened = openCartDrawerByThemeTrigger();
          if (!opened) {
            setTimeout(() => openCartDrawerByThemeTrigger(), 150);
            setTimeout(() => openCartDrawerByThemeTrigger(), 350);
          }
        } catch (err) {
          console.warn("[ml-subscribe-toggle] add failed", err);
          window.location.href = "/cart";
        } finally {
          if (submitBtn) submitBtn.removeAttribute("aria-busy");
        }
      }, true);
    }

    function syncForVariant() {
      const variantId = getCurrentVariantId(form);
      const allocations = getVariantAllocations(productJs, variantId);

      if (!allocations.length) {
        setActiveMode(toggleEl, "otp");
        setSellingPlan(form, null);
        const v = productJs.variants.find((x) => x.id === variantId);
        const otpCents = v?.price ?? 0;
        updatePriceRow(toggleEl, otpCents, otpCents, "otp");
        return;
      }

      buildCadenceMenu(toggleEl, allocations, sellingPlansById);

      const defaultAlloc = allocations[0];
      const defaultSellingPlanId = defaultAlloc?.selling_plan_id || null;
      const v = productJs.variants.find((x) => x.id === variantId);
      const otpCents = v?.price ?? 0;
      const subCents = defaultAlloc?.price ?? otpCents;

      // Update the discount % badge
      const discountEl = toggleEl.querySelector("[data-ml-discount]");
      const pct = deriveDiscountPercent(otpCents, subCents);
      if (pct != null && discountEl) discountEl.textContent = `${pct}%`;

      if (!toggleEl.dataset.mlMode) setActiveMode(toggleEl, "sub");

      const mode = toggleEl.dataset.mlMode || "sub";
      updatePriceRow(toggleEl, otpCents, subCents, mode);

      if (mode === "sub" && defaultSellingPlanId) {
        setSellingPlan(form, defaultSellingPlanId);
      } else {
        setSellingPlan(form, null);
      }

      wireCadenceDropdown(toggleEl, (spId) => {
        const alloc = allocations.find((a) => a.selling_plan_id === spId);
        if (!alloc) return;
        if ((toggleEl.dataset.mlMode || "otp") !== "sub") return;
        setSellingPlan(form, spId);
        const priceCents = alloc.price ?? otpCents;
        updatePriceRow(toggleEl, otpCents, priceCents, "sub");
      });

      const label = toggleEl.querySelector("[data-ml-cadence-label]");
      const sp = sellingPlansById.get(defaultSellingPlanId);
      if (label && sp?.name) label.textContent = sp.name;
    }

    toggleEl.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-ml-purchase]");
      if (!btn) return;

      const mode = btn.dataset.mlPurchase;
      setActiveMode(toggleEl, mode);

      const variantId = getCurrentVariantId(form);
      const allocations = getVariantAllocations(productJs, variantId);
      const defaultAlloc = allocations[0];
      const defaultSellingPlanId = defaultAlloc?.selling_plan_id || null;
      const v = productJs.variants.find((x) => x.id === variantId);
      const otpCents = v?.price ?? 0;
      const subCents = defaultAlloc?.price ?? otpCents;

      updatePriceRow(toggleEl, otpCents, subCents, mode);

      if (mode === "sub" && defaultSellingPlanId) {
        setSellingPlan(form, defaultSellingPlanId);
      } else {
        setSellingPlan(form, null);
      }
    });

    observeVariantChanges(form, syncForVariant);
    syncForVariant();
  }

  function boot() {
    ensureCartCloseWorksOnce();
    document.querySelectorAll("[data-ml-subscribe-toggle]").forEach((el) => {
      initToggle(el).catch((err) => console.warn("[ml-subscribe-toggle] init failed", err));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();